import { useContext } from "react";
import { BtoCWebsocketContext } from "../contexts/BtoCWebsocketContext";

export const useBToCWebsocket = () => {
  const { sendMessage, sendTyping, sendStopTyping, readyState, handleSetNextReference, displayLatestMessage, handleSetShouldScrollToBottom, nextReference, isLatestMessageExist, handleSetMessageList, handleNewMessages, shouldScrollToBottom, cleanShouldScrollToBottom
  } =
    useContext(BtoCWebsocketContext);
  return { sendMessage, sendTyping, sendStopTyping, readyState, handleSetNextReference, displayLatestMessage, handleSetShouldScrollToBottom, nextReference, isLatestMessageExist, handleSetMessageList, handleNewMessages, shouldScrollToBottom, cleanShouldScrollToBottom
  };
};
